var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetFont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18c0 4.41-3.586 8-8 8s-8-3.59-8-8 3.586-8 8-8l2.359 0.027-1.164 1.164 2.828 2.828 6.012-6.019-6.012-6-2.828 2.828 1.18 1.172h-2.375c-6.625 0-12 5.371-12 12s5.375 12 12 12 12-5.371 12-12h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFont);
export default __webpack_public_path__ + "static/media/reset-font.434e7b02bbd31ad909ac35ca1057769a.svg";
export { ForwardRef as ReactComponent };